// Cache mémoire des données de pages.
//
// Survit à la navigation SPA (les composants sont démontés mais le module
// reste chargé) — pas au rechargement complet (F5). Usage type :
//   1. Au montage : si le cache a des données → affichage immédiat, pas de loader.
//   2. Refetch silencieux en arrière-plan pour se resynchroniser.
// Le temps réel (Mercure) maintient de toute façon les données fraîches tant
// que la page est ouverte.

const cache = new Map();

export function getPageCache(key) {
    return cache.get(key);
}

/** Fusionne `value` avec l'entrée existante (permet des mises à jour partielles). */
export function setPageCache(key, value) {
    cache.set(key, { ...(cache.get(key) || {}), ...value });
}
